<template>
  <div class="nav-tabs">
    <el-tabs v-model="editableTabsValue" type="card" @tab-click="toPath" @tab-remove="remove">
      <el-tab-pane :key="item.name" :closable="index!==0" v-for="(item, index) in editableTabs" :label="item.title" :name="item.name">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

export default {
  name: "NavTabs",
  data() {
    return {
      editableTabsValue: "0",
      editableTabs: [],
    }
  },
  mounted() {
    let that=this
    setTimeout(()=>{
      that.editableTabs=JSON.parse(window.sessionStorage.getItem('visitedRoutes'))||[]
      that.editableTabs.map((v,i)=>v.name=i+'')
      let currentRouterTitle=window.sessionStorage.getItem('currentRouterTitle')
      let tab=this.editableTabs.find(item=>item.title===currentRouterTitle)
      this.editableTabsValue=tab.name
    },100)
  },
  methods: {
    toPath(tab) {
      let route = this.editableTabs.find(item=>item.title===tab.label)
      window.sessionStorage.setItem('currentRouterTitle',route.title)
      window.sessionStorage.setItem('navTop',route.active)
      this.$router.push({path:route.path})
    },
    remove(targetName){
      // this.editableTabs.splice(targetName,1)
      let tabs=this.editableTabs
      let activeName=this.editableTabsValue
      if(activeName===targetName){
        tabs.forEach((tab,index)=>{
          if(tab.name===targetName){
            let nextTab=tabs[index+1]||tabs[index-1]
            if(nextTab)activeName=nextTab.name
          }
        })
      }
      this.editableTabsValue=activeName
      this.editableTabs=tabs.filter(tab=>tab.name!==targetName)
      let currentTab=this.editableTabs.find(item=>item.name===this.editableTabsValue)
      window.sessionStorage.setItem('currentRouterTitle',currentTab.title)
      window.sessionStorage.setItem('navTop',currentTab.active)
      window.sessionStorage.setItem('visitedRoutes',JSON.stringify(this.editableTabs))
      this.$router.push({path:currentTab.path})
    },
    handleTabsEdit(targetName, action) {
      if (action === 'add') {
        let newTabName = ++this.tabIndex + '';
        this.editableTabs.push({
          title: 'New Tab',
          name: newTabName,
          content: 'New Tab content'
        });
        this.editableTabsValue = newTabName;
      }
      if (action === 'remove') {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }

        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      }
    }
  },
  watch:{
    $route(){
      let currentRouterTitle=window.sessionStorage.getItem('currentRouterTitle')

      this.editableTabs=JSON.parse(window.sessionStorage.getItem('visitedRoutes'))||[]
      this.editableTabs.map((v,i)=>v.name=i+'')
      let tab=this.editableTabs.find(item=>item.title===currentRouterTitle)
      this.editableTabsValue=tab.name
      // this.toPath(tab)
    }
  }
}
</script>

<style scoped lang="less">
.nav-tabs{
  width: 100%;
  padding: 0 40px;
  background: #104079;
  //border-bottom: 1px solid #E4E7ED;
}
/deep/.el-tabs__header{
  margin: 0;
}
/deep/.el-tabs__item{
  font-size: 12px;/*no*/
  background: rgba(74, 105, 148, 1);
  color: #D7D7D7;
  height: 26px;/*no*/
  line-height: 26px;/*no*/
  padding: 0 30px 0 12px;/*no*/
  margin-right: 8px;/*no*/
}
/deep/.el-tabs__item:hover{
  color: rgba(16, 64, 121, 1) !important;
  background: #fff;
  font-weight: bold;
}
/deep/.el-tabs__item.is-active{
  color: rgba(16, 64, 121, 1) !important;
  background: #fff;
  font-weight: bold;
}
/deep/.el-tabs--card>.el-tabs__header{
  border-bottom: none;
}
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item:hover .el-icon-close{
  width: 16px!important;/*no*/
  height: 16px;/*no*/
  line-height: 16px;/*no*/
  font-size: 16px;/*no*/
  //text-align: center;/*no*/
}
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable .el-icon-close{
  width: 16px!important;/*no*/
  height: 16px;/*no*/
  line-height: 16px;/*no*/
  font-size: 16px;/*no*/
  text-align: center;
}
/deep/.el-tabs--card>.el-tabs__header .el-tabs__nav{
  border:none;
}
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item{
  border: none;
  border-top-left-radius: 4px;/*no*/
  border-top-right-radius: 4px;/*no*/
}
/deep/.el-tabs__nav-wrap{
  margin-bottom: 0;
}
/deep/.el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item{
  //padding: 0 30px 0 12px !important;/*no*/
  padding: 0 0 0 12px !important;/*no*/
  width: 120px !important;/*no*/
  text-align: left;
  position: relative !important;
}
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item .el-icon-close{
  //right: -8px;/*no*/
  position: absolute !important;/*no*/
  top: 5px !important;/*no*/
  right: 12px !important;/*no*/
}
/deep/.el-icon-arrow-left,/deep/.el-icon-arrow-right{
  font-size: 20px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/NavTabs/NavTabs.vue